<template>
   <v-container fluid>
      <v-row>
         <v-toolbar dense color="primary white--text" bottom>
            <v-toolbar-title v-if="$vuetify.breakpoint.mdAndUp">
               Participant List
            </v-toolbar-title>
            <v-icon color="white" v-else>mdi-download</v-icon>

            <v-spacer></v-spacer>
            <v-toolbar-items class="pa-2">
               <v-card max-width="250px" flat color="primary">
                  <v-select
                     dark
                     v-model="termyearselect"
                     :items="termyear"
                     item-text="termyeartext"
                     item-value="id"
                     label="Select"
                     return-object
                     single-line
                     @change="changeTerm"
                  >
                  </v-select>
               </v-card>
            </v-toolbar-items>
         </v-toolbar>
      </v-row>
      <v-row class="px-3">
         <v-col cols="6" md="6">
            <v-select
               v-model="schedule_select"
               :items="schedulelist"
               item-text="schedule_name"
               item-value="id"
               label="Select Schedule"
               return-object
               @change="loadGroupBySchedule"
            ></v-select>
         </v-col>
         <v-spacer></v-spacer>
         <v-col cols="4" md="4">
            <v-text-field
               :disabled="groupdata.length == 0"
               label="Search"
               v-model="searchField"
               hide-details
               clearable
            ></v-text-field>
         </v-col>
      </v-row>
      <v-row class="px-3">
         <v-col cols="12" md="12">
            <v-card class="my-2" v-for="(group, i) in groupdata" :key="i">
               <v-row class="pb-2">
                  <v-col cols="8" md="8">
                     <strong>{{ group.cca_name }}</strong>
                  </v-col>
                  <v-col cols="4" md="4">
                     <v-btn
                        small
                        :disabled="group.participants.length == 0"
                        outlined
                        color="indigo"
                        @click="generateParticipantList(group)"
                     >
                        Export List
                     </v-btn>
                  </v-col>
               </v-row>
               <v-data-table
                  :search="searchField"
                  dense
                  item-key="id"
                  :items="group.participants"
                  :headers="participant_headers"
               ></v-data-table>
            </v-card>
         </v-col>
      </v-row>

      <!-- Progress Dialog -->
      <v-dialog v-model="loadgroup_progress" persistent max-width="40vh">
         <v-card height="15vh" width="40vh" outlined>
            <div class="text-center">
               <p class="pt-2">Loading...</p>
               <v-progress-circular indeterminate color="teal"> </v-progress-circular>
            </div>
         </v-card>
      </v-dialog>

      <confirm-dlg ref="confirm"></confirm-dlg>
   </v-container>
</template>

<script>
   import ConfirmDlg from "@/components/ConfirmDlg.vue";
   import ShowToast from "@/components/showToast.vue";

   export default {
      inject: ["ShowMessage"],

      components: {ConfirmDlg, ShowToast},

      data() {
         return {
            termyearselect: null,
            termyear: [],

            schedule_select: null,
            schedulelist: [],

            yeargroupselect: [],

            loadgroup_progress: false,

            schedule_header: [
               {
                  text: "Sch Name",
                  value: "schedule_name",
                  width: "15%",
                  sortable: true,
                  class: this.$globalstore.table_smallheaderclass,
               },
            ],

            searchField: "",
            groupdata: [],

            participant_headers: [
               {
                  text: "Student Name",
                  value: "fullname",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Code",
                  value: "student_code",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Year",
                  value: "yeargrouptext",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Form",
                  value: "yearform",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Gender",
                  value: "gendertext",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Type",
                  value: "subtypetext",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Fee",
                  value: "fee_amount",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Due Date",
                  value: "due_date",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Status",
                  value: "consentstatustext",
                  class: this.$globalstore.table_smallheaderclass,
               },
            ],
         };
      },

      methods: {
         SetTermYear() {
            if (this.termyear.length > 0) {
               if (this.$globalstore.currentyear && this.$globalstore.currentterm) {
                  this.termyearselect = this.termyear.find(
                     (x) =>
                        x.year == this.$globalstore.currentyear &&
                        x.term == this.$globalstore.currentterm
                  );
               } else {
                  this.termyearselect = this.termyear.find(
                     (x) => x.id == this.$globalstore.appsettings.currentyearterm.id
                  );
               }
            }
         },

         generateParticipantList(group) {
            if (group.participants.length > 0) {
               this.$refs.confirm
                  .open(
                     "Confirm",
                     "Are you sure you want to export the participant list for " +
                        `${group.cca_name}?`,
                     {
                        color: "primary",
                        noconfirm: false,
                     }
                  )
                  .then((reply) => {
                     if (reply) {
                        this.doExportList(group.cca_id);
                     }
                  });
            }
         },

         async doExportList(ccaid) {
            await this.$http({
               url: "/cca/exportparticipantlist.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  cca_id: ccaid,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
               responseType: "blob",
            }).then((response) => {
               if (!(response.data instanceof Blob)) {
                  if (response.data.autherror) {
                     this.$globalstore.user.tokenexpired = true;
                  } else {
                     if (response.data.error) {
                        this.ShowMessage({
                           title: "Error",
                           message: response.data.message,
                           color: "red",
                        });
                     }
                     return;
                  }
               } else {
                  const url = window.URL.createObjectURL(response.data);
                  try {
                     const link = document.createElement("a");
                     link.href = url;
                     let filename = "ParticipantList.xlsx";
                     link.setAttribute("download", filename);
                     document.body.appendChild(link);
                     link.click();
                  } finally {
                     window.URL.revokeObjectURL(url);
                     this.report_in_progress = false;
                  }
               }
            });
         },

         changeTerm() {
            if (this.termyearselect) {
               this.$globalstore.currentyear = this.termyearselect.year;
               this.$globalstore.currentterm = this.termyearselect.term;
               this.getScheduleList();
            }
         },

         async getScheduleList() {
            await this.$http({
               url: "/cca/getschedulelist.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  cca_year: this.termyearselect.year,
                  cca_term: this.termyearselect.term,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.schedulelist = response.data.scheduledata;
                  }
               }
            });
         },

         async loadGroupBySchedule() {
            this.groupdata = [];
            this.loadgroup_progress = true;
            await this.$http({
               url: "/cca/getgroup_byschedule.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  schedule_id: this.schedule_select.id,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               try {
                  if (response.data.autherror) {
                     this.$globalstore.user.tokenexpired = true;
                  } else {
                     if (response.data.error) {
                        this.ShowMessage({
                           title: "Error",
                           message: response.data.message,
                           color: "red",
                        });
                     } else {
                        this.groupdata = response.data.groupdata;
                     }
                  }
               } finally {
                  this.loadgroup_progress = false;
               }
            });
         },
      },

      async mounted() {
         if (this.$globalstore && this.$globalstore.appready) {
            this.termyear = this.$globalstore.termyearlist;
            this.SetTermYear();

            await this.getScheduleList();
         }
      },
   };
</script>
